import { render } from "./vdvcprint.vue?vue&type=template&id=70cc1b78&scoped=true"
import script from "./vdvcprint.vue?vue&type=script&lang=js"
export * from "./vdvcprint.vue?vue&type=script&lang=js"

import "./vdvcprint.vue?vue&type=style&index=0&id=70cc1b78&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cc1b78"]])

export default __exports__